export enum WebGuideAccessories {
    ProductGroup = 'web_guide_accessories.product_group',
}
